import {
    TFundingRequirement,
    TIdVerificationPerson
} from './fundingRequirements.types';

// The first person on the id_verification requirement whose ID check failed, who has to send their ID check SMS again.
export const getIdVerificationPersonWithError = ({
    people = []
}: TFundingRequirement): TIdVerificationPerson | undefined =>
    people.find(({ status }) => status === 'error');
